import { privateInstance } from "../configs";

const employeApi = {
  // async getEmployesPays() {
  //   const res = await privateInstance.get("/employe/api/employes/pay/cl/");
  //   return res.data;
  // },
  // async postEmployePay(pay) {
  //   const res = await privateInstance.post(
  //     "/employe/api/employes/pay/cl/",
  //     pay
  //   );
  //   return res.data;
  // },
  // async putEmployePay(id, pay) {
  //   const res = await privateInstance.put(
  //     `/employe/api/employes/pay/rud/${id}/`,
  //     pay
  //   );
  //   return res.data;
  // },
  // async deleteEmployePay(id) {
  //   const res = await privateInstance.delete(
  //     `/employe/api/employes/pay/rud/${id}/`
  //   );
  //   return res.data;
  // },
  async getEmployes() {
    const res = await privateInstance.get("/employe/api/employes/cl/");
    return res.data;
  },
  async postEmploye(employe) {
    const res = await privateInstance.post(
      "/employe/api/employes/cl/",
      employe
    );
    return res.data;
  },
  async retrieveEmploye(id) {
    const res = await privateInstance.get(`/employe/api/employes/rud/${id}/`);
    return res.data;
  },
  async putEmploye(id, employe) {
    const res = await privateInstance.put(
      `/employe/api/employes/rud/${id}/`,
      employe
    );
    return res.data;
  },
  async deleteEmploye(id) {
    const res = await privateInstance.delete(
      `/employe/api/employes/rud/${id}/`
    );
    return res.data;
  },
  async getEmployesPaysWeek(store) {
    const res = await privateInstance.get(`employe/api/weeks/list/${store}/`);
    return res.data;
  },
  async getEmployesForDate(store, date) {
    const res = await privateInstance.get(
      `employe/api/weeks/employes/list/${store}?date=${date.toString()}`
    );
    return res.data;
  },
  async updateEmployeHour(id, hour) {
    const res = await privateInstance.put(
      `employe/api/weeks/hours/update/${id}`,
      hour
    );
    return res.data;
  },
  async createEmployeHour(hour) {
    const res = await privateInstance.post(
      `employe/api/weeks/hours/create/`,
      hour
    );
    return res.data;
  },
  async getEmployeHourForRange(store, start, end) {
    const res = await privateInstance.get(
      `employe/api/weeks/employes/range/${store}?start=${start}&end=${end}/`
    );
    return res.data;
  },
  async getEmployeHourForRangeGlobal(start, end) {
    const res = await privateInstance.get(
      `employe/api/weeks/employes/range?start=${start}&end=${end}/`
    );
    return res.data;
  },
  async getEmployeSalaryList(id) {
    const res = await privateInstance.get(`employe/api/employes/salaries/${id}/
    `);
    return res.data;
  },
  async postEmployeSalary(id, salary) {
    const res = await privateInstance.post(
      `employe/api/employes/salaries/${id}/
    `,
      salary
    );
    return res.data;
  },
  async putEmployeSalary(id, salary) {
    const res = await privateInstance.put(
      `employe/api/employes/salaries/rud/${id}/
    `,
      salary
    );
    return res.data;
  },
  async deleteEmployeSalary(id) {
    const res = await privateInstance.delete(
      `employe/api/employes/salaries/rud/${id}/
    `
    );
    return res.data;
  }
};

export { employeApi };
